import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Chip
} from "@mui/material";

// 帮助函数，根据变化数值输出 Chip
function renderChangeChip(value) {
  if (value === null || value === undefined) {
    return <Chip label="無數據" size="small" />;
  }

  if (Math.abs(value) < 0.01) {
    return <Chip label="持平" size="small" color="default" />;
  }

  if (value > 0.01) {
    return (
      <Chip
        label={`貶值 ${value.toFixed(2)}%`}
        size="small"
        color="error"
      />
    );
  }

  if (value < -0.01) {
    return (
      <Chip
        label={`升值 ${Math.abs(value).toFixed(2)}%`}
        size="small"
        color="success"
      />
    );
  }

  return <Chip label="持平" size="small" />;
}

export default function ForexTable({ forexData }) {
  return (
    <TableContainer component={Paper} sx={{ mt: 2, mb: 2 }}>
      <Table 
        size="small"
        sx={{
          '& .MuiTableCell-root': {
            py: 1,     // 上下padding：0.75 * 8px = 6px
            px: 2,        // 左右padding：2 * 8px = 16px
            fontSize: '1rem',  // 字体大小：16px（默认是14px）
          },
          '& .MuiTableHead-root .MuiTableCell-root': {
            py: 1,        // 表头稍微大一点
            fontWeight: 600,
            fontSize: '1.05rem',  // 表头字体：16.8px
          }
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>貨幣</TableCell>
            <TableCell>最新日期</TableCell>
            <TableCell>最新匯率</TableCell>
            <TableCell>較一天前</TableCell>
            <TableCell>較一月前</TableCell>
            <TableCell>較一年前</TableCell>
            <TableCell>較十年前</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.entries(forexData || {}).map(([symbol, info]) => (
            <TableRow 
              key={symbol}
              sx={{
                '&:hover': {
                  backgroundColor: 'action.hover',
                },
              }}
            >
              <TableCell>{symbol}</TableCell>
              <TableCell>{info?.latest?.date || "-"}</TableCell>
              <TableCell>{info?.latest?.value ?? "-"}</TableCell>
              <TableCell>{renderChangeChip(info?.chg_d_1d)}</TableCell>
              <TableCell>{renderChangeChip(info?.chg_d_1m)}</TableCell>
              <TableCell>{renderChangeChip(info?.chg_d_1y)}</TableCell>
              <TableCell>{renderChangeChip(info?.chg_d_10y)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}